import { useId } from 'react';
import { DialogLayer } from '../ui/Dialog';

/**
 * Owner 2026-10-28 21:37 (the approved proposal): „Niedostępny” on a day I work asks first — „Wycofujesz się z obsady:
 * Wesele A, 7.11?”. „Tak”: I leave that crew („Odmowa”, the coordinators are told); „Nie”: those days stay as they were
 * (the other days are marked). Esc / „Anuluj”: nothing is saved.
 */
export function WithdrawAsk({ message, busy, onAnswer, onClose }: { message: string; busy: boolean; onAnswer: (withdraw: boolean) => void; onClose: () => void }) {
  const title = useId();
  return (
    <div className="dialog-backdrop">
      <div className="dialog panel" role="alertdialog" aria-modal="true" aria-labelledby={title} data-feature-id="crew.my_availability">
        <DialogLayer onClose={onClose} busy={busy} />
        <h2 id={title}>{message}</h2>
        <p>„Tak” — wypisujesz się z tej obsady (status „Odmowa”), a koordynator dostanie powiadomienie. „Nie” — dni, w których pracujesz, zostaną bez zmian (inne wybrane dni dostaną „Niedostępny”).</p>
        <div className="actions">
          <button type="button" className="btn primary" disabled={busy} onClick={() => onAnswer(true)}>
            Tak
          </button>
          <button type="button" className="btn" disabled={busy} onClick={() => onAnswer(false)}>
            Nie
          </button>
          <button type="button" className="btn ghost" disabled={busy} onClick={onClose}>
            Anuluj
          </button>
        </div>
      </div>
    </div>
  );
}
